import useSWR from 'swr';
import { postFetcher } from '../../swr/fetchers';
import { HookOptionsTypes } from '../../types/HookOptionsTypes';
import { useToken } from '../useToken';

export type SpreedlySessionData = {
  nonce: string;
  timestamp: number;
  certificateToken: string;
  signature: string;
};

const SPREEDLY_SESSION_ENDPOINT = '/v1/payment-methods/sign';

// Stable fetcher reference - defined outside the hook to avoid recreation on every render
const spreedlySessionFetcher = postFetcher();

/**
 * Fetch Spreedly session/certificate data for payment form initialization.
 * This is a POST request to /v1/payment-methods/sign.
 *
 * @param options - Optional SWR hook options.
 * @returns The Spreedly session data including nonce, timestamp, certificateToken, and signature.
 */
export const useSpreedlySession = ({
  skip = false,
  ...options
}: HookOptionsTypes = {}) => {
  const token = useToken();

  // SWR key includes all parameters needed by the fetcher [url, payload, token]
  // When token changes, the key changes, triggering a new fetch
  const swrKey =
    skip || !token
      ? null
      : [SPREEDLY_SESSION_ENDPOINT, JSON.stringify({}), token];

  return useSWR<SpreedlySessionData>(swrKey, spreedlySessionFetcher, {
    ...options,
  });
};

export default useSpreedlySession;
